import { handleResponseOld, makeGet } from './helpers';
import { ApprovalStatus } from '@/types/Approval';

/**
 * @category Approval API
 * @see fetchBidLimitBalance
 */
type FetchBidLimitBalanceParams = {
    authToken: string;
    bidderId: number;
    catalogId: number;
    deployment: string;
};

export type FetchBidLimitBalanceResponse = {
    error: boolean;
    payload: {
        approvalStatus: ApprovalStatus;
        bidLimit: number;
        bidLimitRemaining: number;
        bidderId: number;
        catalogId: number;
    };
};

/**
 * GET request to approval API service that returns bid limits for given bidder and catalog
 * @function fetchBidLimitBalance
 * @category Approval API
 * @param {FetchBidLimitBalanceParams}
 * @returns {FetchBidLimitBalanceResponse}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/approval/catalog/${catalogId}/bidder/${bidderId}/bidLimit
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/ou2a17vn9h/resources/s5oicr/methods/GET
 * @see https://github.com/LIVEauctioneers/approval/tree/master/functions/GetBidLimitRemaining
 */
export const fetchBidLimitBalance = ({ authToken, bidderId, catalogId, deployment }: FetchBidLimitBalanceParams) =>
    new Promise<FetchBidLimitBalanceResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `catalog/${catalogId}/bidder/${bidderId}/bidLimit`,
            authToken,
            deployment,
            path: '<APPROVAL-API>',
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
